module.exports = __webpack_public_path__ + "img/gift.c207a1ab.png";